import { render } from "./PR8-041322.vue?vue&type=template&id=232eb282"
import script from "./PR8-041322.vue?vue&type=script&lang=js"
export * from "./PR8-041322.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__